"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockRouterProvider = void 0;
var react_1 = __importDefault(require("react"));
var helpers_1 = require("../helpers");
var router_1 = require("./router");
function MockRouterProvider(props) {
    var _a = props.pathname, pathname = _a === void 0 ? '/' : _a, query = props.query, children = props.children;
    var router = (0, helpers_1.createMockRouter)({
        pathname: pathname,
        query: query,
    });
    return react_1.default.createElement(router_1.RouterContext.Provider, { value: router }, children);
}
exports.MockRouterProvider = MockRouterProvider;
